<template>
  <div style="height: 100%">
    <WbList
      style="height: 100%"
      v-if="showMain"
      :grouptreeProp="grouptreeProp"
      :changeView="changeView"
    ></WbList>
    <AddAccount
      v-if="!showMain"
      :grouptreeProp="grouptreeProp"
      :changeView="changeView"
      :groupId="curGroupId"
    />
  </div>
</template>

<script>
import WbList from './WbList'
import AddAccount from './AddAccount'
import { mapActions } from 'vuex'
export default {
  name: '',
  data() {
    return {
      showMain: true,
      // 配置项（必选）
      grouptreeProp: {
        children: 'children',
        label: 'name'
      },
      curGroupId: ''
    }
  },
  components: {
    WbList,
    AddAccount
  },
  computed: {
  },
  mounted() {
    this._listRoles()
    // this._listUser({ groupId: '' })
    // 加载坐席组数据,不带坐席成员
    this._getUserGroupTree({ type: '0' })
  },
  methods: {
    ...mapActions('user', ['_getUserGroupTree', '_listUser']),
    ...mapActions('role', ['_listRoles']),
    changeView(target) {
      this.showMain = target
    }
  }
}
</script>
